import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';
import type { ReferralsTerm } from '@core/referrals-types';

@Injectable({ providedIn: 'root' })
export class TermsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public loadTerms(): Observable<ReferralsTerm[]> {
    return this.httpApi.get('/terms').pipe(map(data => data.terms));
  }
}
